import { PayloadAction } from '@reduxjs/toolkit';
import createAsyncSlice from '../createAsyncSlice';

/**
 * Represents a model type User | Question | Answer.
 */
export enum ModelType {
  UserT = 'User',
  QuestionT = 'Question',
  AnswerT = 'Answer',
}

/**
 * Represents a list of all model types.
 */
export const MODELTYPES = [ModelType.UserT, ModelType.QuestionT, ModelType.AnswerT];

/**
 * Represents the state of the explore page.
 */
export interface ExploreSliceState {
  rankingType: ModelType;
  trendType: ModelType;
  status: 'idle' | 'loading' | 'failed';
}

/**
 * Represents the initial state of the explore page.
 */
const initialState: ExploreSliceState = {
  rankingType: ModelType.UserT,
  trendType: ModelType.UserT,
  status: 'idle',
};

/**
 * Creates reducers and selectors with which to used to interact with the explore page state.
 */
export const exploreSlice = createAsyncSlice({
  name: 'exploreSlice',
  initialState,
  reducers: create => ({
    // Update's the state's ranking type with the given ModelType
    setRankingType: create.reducer((state, action: PayloadAction<ModelType>) => {
      state.rankingType = action.payload;
    }),
    // Update's the state's trend type with the given ModelType
    setTrendType: create.reducer((state, action: PayloadAction<ModelType>) => {
      state.trendType = action.payload;
    }),
  }),
  selectors: {
    rankingTypeSelector: state => state.rankingType,
    trendTypeSelector: state => state.trendType,
  },
});

export const { setRankingType, setTrendType } = exploreSlice.actions;

export const { rankingTypeSelector, trendTypeSelector } = exploreSlice.selectors;
